var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout type-profile"},[_c('main-navbar'),_c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('div',{staticClass:"profiles"},[(!_vm.isAcademic)?_c('sidebar-item',{staticClass:"sidebar-item-plus",attrs:{"link":{
              name: 'Prospect Search',
              icon: 'source',
              path: '/prospect-search',
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Financial',
              icon: 'card_travel',
              path: '/new-profile/industry-financial-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Market',
              icon: 'leaderboard',
              path: '/new-profile/industry-market-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Companies',
              icon: 'business',
              path: '/company-search',
            }}}),_c('div',{staticClass:"disable"},[(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
                name: 'Market',
                icon: 'insights',
                path: '/',
              }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
                name: 'Franchise',
                icon: 'store',
                path: '/',
              }}}):_vm._e()],1),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Financial Report',
              icon: 'text_snippet',
              path: '/create-report-format/financial',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Market Report',
              icon: 'newspaper',
              path: '/create-report-format/market',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Report',
              icon: 'request_quote',
              path: '/create-report-format/valuation',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Company Report',
              icon: 'summarize',
              path: '/create-report-format/company',
            }}}):_vm._e()],1),(!_vm.isAcademic)?_c('div',{staticClass:"section_wpr"},[_vm._v("My Data")]):_vm._e(),_c('div',{staticClass:"profiles border-0"},[(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Prospect List',
              icon: 'format_list_bulleted',
              path: '/my-prospect-lists',
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
              name: 'Profiles',
              icon: 'folder_open',
              path: '/my-profiles',
            }}}),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Reports',
              icon: 'description',
              path: '/my-reports',
            }}}):_vm._e(),(!_vm.isAcademic)?_c('sidebar-item',{attrs:{"link":{
              name: 'Data',
              icon: 'dns',
              path: '/my-data',
            }}}):_vm._e()],1)])],2),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),(!_vm.spif)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: '/if/' + this.id + '/about',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Information',
            icon: 'chat_bubble',
            path: '/if/' + this.id + '/introduction',
            type: 'product',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'financial-fundamentals' }),expression:"{ name: 'financial-fundamentals' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Financials',
              icon: 'analytics',
              path: '/if/' + this.id + '/financial-fundamentals',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'ratios' }),expression:"{ name: 'ratios' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Ratios',
              icon: 'scatter_plot',
              path: '/if/' + this.id + '/ratios',
              type: 'product',
            }}})],1),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber disabled-item' : '',attrs:{"link":{
            name: 'Valuation Multiples',
            icon: 'query_stats',
            path: !this.isRetail
              ? '/if/' + this.id + '/valuation-multiples'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}})],1):_vm._e(),(_vm.spif)?_c('template',{slot:"links"},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: '/spif/' + this.id + '/about',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Information',
            icon: 'chat_bubble',
            path: '/spif/' + this.id + '/introduction',
            type: 'product',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'profit-and-loss' }),expression:"{ name: 'profit-and-loss' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Profit & Loss',
              icon: 'analytics',
              path: '/spif/' + this.id + '/profit-and-loss',
              type: 'product',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'ratios' }),expression:"{ name: 'ratios' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Ratios',
              icon: 'scatter_plot',
              path: '/spif/' + this.id + '/ratios',
              type: 'product',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cash Tables',
            icon: 'collections_bookmark',
            path: '/spif/' + this.id + '/cash-tables',
            type: 'product',
          }}}),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber disabled-item' : '',attrs:{"link":{
            name: 'Valuation Multiples',
            icon: 'query_stats',
            path: !this.isRetail
              ? '/spif/' + this.id + '/valuation-multiples'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}})],1):_vm._e()],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(_vm.insufficientData && !_vm.loading)?_c('div',{staticClass:"insufficient-data-panel md-layout-item"},[_c('h2',[_vm._v("No data available for this segment")]),_c('p',[_vm._v(" This release doesn't have industry financial data for the selected NAICS, geography and sales-class combination, so this report can't be generated. Try a broader sales class or a parent industry. ")])]):_vm._e(),((!_vm.loading || _vm.isAboutRoute) && !_vm.insufficientData)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }